import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../../helpers/utility';

const initialState = {
    isExpired: false,
    responseCode: 0,
    reason: null,
    loading: false,
  };

  const agentValidateStart= (state, action)=>{
    return updateObject(state, {error:null, loading:true});
  }
  
  const agentValidateSuccess = (state,action) =>{
    return updateObject(state, {
      isExpired: action.isExpired,
      responseCode: action.responseCode,
      reason: action.reason,
      loading:false,
    })
  }
  
  const agentValidateFail = (state,action) =>{
    return updateObject(state,{
      isExpired: action.isExpired,
      responseCode: action.responseCode,
      reason: action.reason,
      loading: false,
    })
  }
  
  const changeAgentPasswordStart = (state,action) =>{
    return updateObject(state, {error: null, loading:true});
  }
  
  const changeAgentPasswordSuccess = (state,action) =>{
    return updateObject(state, {
      responseCode: action.responseCode,
      reason: action.reason,
      loading: false,
    })
  }
  const changeAgentPassowordFail = (state, action)=>{
    return updateObject(state, {
      responseCode: action.responseCode,
      error: action.error,
      loading: false,
    })
  }

  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case actionTypes.AGENT_VALIDATE_START:
         return agentValidateStart(state,action);
      case actionTypes.AGENT_VALIDATE_SUCCESS:
        return agentValidateSuccess(state,action);
      case actionTypes.AGENT_VALIDATE_FAIL:
          return agentValidateFail(state,action);
      case actionTypes.AGENT_PASSWORD_Start:
            return changeAgentPasswordStart(state,action);
      case actionTypes.AGENT_PASSWORD_SUCCESS:
           return changeAgentPasswordSuccess(state,action);
      case actionTypes.AGENT_PASSWORD_FAIL:
             return changeAgentPassowordFail(state,action);
      default:
        return state;
    }
  };
  
  export default reducer;